const HIDDEN_FIELDS = new Set([
  'lat',
  'lon',
  'coords',
  'mileage_on_gps',
  'mileage_on_roads',
  'mileage_approach',
  'arrival_time_by_coords',
  'odometer_start',
  'route',
  'point_coords',
]);

const HIDDEN_LABEL_PARTS = [
  'широта',
  'долгота',
  'координат',
  'пробег по gps',
  'пробег по дорогам',
  'порожний пробег',
  'время прибытия',
  'одометр',
  'геометр',
  'геолокац',
];


export function filterHistoryChanges(changes) {
  if (!Array.isArray(changes)) {
    return [];
  }

  return changes.filter((change) => {
    if (change.field && HIDDEN_FIELDS.has(change.field)) {
      return false;
    }
    const label = (change.label || '').toLowerCase();
    return !HIDDEN_LABEL_PARTS.some((part) => label.includes(part));
  });
}


export function filterHistoryItems(items) {
  if (!Array.isArray(items)) {
    return [];
  }

  return items.reduce((result, item) => {
    const changes = filterHistoryChanges(item.changes);
    if (item.action === 'UPDATE' && changes.length === 0 && Array.isArray(item.changes) && item.changes.length > 0) {
      return result;
    }
    result.push({
      ...item,
      changes,
    });
    return result;
  }, []);
}
